import { logger } from './logger';

export enum ErrorCategory {
  NETWORK = 'NETWORK',
  FIREBASE = 'FIREBASE',
  VALIDATION = 'VALIDATION',
  AUTH = 'AUTH',
  UNKNOWN = 'UNKNOWN'
}

export interface AppError {
  message: string;
  category: ErrorCategory;
  originalError?: unknown;
  userMessage: string;
}

class ErrorHandler {
  /**
   * Behandelt einen Fehler zentral.
   * Loggt den Fehler und gibt eine strukturierte AppError-Instanz zurück.
   */
  handle(error: unknown, context?: string): AppError {
    const category = this.categorize(error);
    const userMessage = this.getUserMessage(category, error);
    
    const message = error instanceof Error ? error.message : String(error);

    const appError: AppError = {
      message,
      category,
      originalError: error,
      userMessage
    };

    logger.error(`[${category}] ${context || 'Fehler'}:`, error);

    return appError;
  }

  private categorize(error: unknown): ErrorCategory {
    if (!error) return ErrorCategory.UNKNOWN;

    const message = error instanceof Error ? error.message.toLowerCase() : String(error).toLowerCase();
    // @ts-ignore - Handle Firebase errors that might have a code property
    const code = (error?.code || '').toLowerCase();

    if (code.includes('auth/') || message.includes('auth')) {
      return ErrorCategory.AUTH;
    }

    if (code.includes('permission-denied') || message.includes('firestore') || message.includes('storage')) {
      return ErrorCategory.FIREBASE;
    }

    if (message.includes('network') || message.includes('fetch') || message.includes('failed to fetch')) {
      return ErrorCategory.NETWORK;
    }

    if (message.includes('validation') || message.includes('invalid') || message.includes('required')) {
      return ErrorCategory.VALIDATION;
    }

    return ErrorCategory.UNKNOWN;
  }

  private getUserMessage(category: ErrorCategory, _error: unknown): string {
    switch (category) {
      case ErrorCategory.AUTH:
        return 'Fehler bei der Authentifizierung. Bitte prüfen Sie Ihre Anmeldedaten.';
      case ErrorCategory.FIREBASE:
        return 'Datenbankfehler. Bitte versuchen Sie es später erneut.';
      case ErrorCategory.NETWORK:
        return 'Netzwerkfehler. Bitte prüfen Sie Ihre Internetverbindung.';
      case ErrorCategory.VALIDATION:
        return 'Ungültige Eingabe. Bitte prüfen Sie Ihre Daten.';
      default:
        return 'Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.';
    }
  }
}

export const errorHandler = new ErrorHandler();
export default errorHandler;

